"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmEmailType = exports.UnsubscribeReason = exports.ContactCommunicationType = exports.EmailDeliveryStatus = exports.EmailType = exports.SendinblueAllowedExtensions = void 0;
var SendinblueAllowedExtensions;
(function (SendinblueAllowedExtensions) {
    SendinblueAllowedExtensions["PDF"] = "pdf";
    SendinblueAllowedExtensions["TXT"] = "txt";
    SendinblueAllowedExtensions["DOCX"] = "docx";
    SendinblueAllowedExtensions["PPTX"] = "pptx";
    SendinblueAllowedExtensions["XLSX"] = "xlsx";
    SendinblueAllowedExtensions["GIF"] = "gif";
    SendinblueAllowedExtensions["JPG"] = "jpg";
    SendinblueAllowedExtensions["JPEG"] = "jpeg";
    SendinblueAllowedExtensions["PNG"] = "png";
    SendinblueAllowedExtensions["TIF"] = "tif";
    SendinblueAllowedExtensions["TIFF"] = "tiff";
    SendinblueAllowedExtensions["BMP"] = "bmp";
    SendinblueAllowedExtensions["MP3"] = "mp3";
    SendinblueAllowedExtensions["M4A"] = "m4a";
    SendinblueAllowedExtensions["M4V"] = "m4v";
    SendinblueAllowedExtensions["WAV"] = "wav";
    SendinblueAllowedExtensions["MP4"] = "mp4";
    SendinblueAllowedExtensions["MOV"] = "mov";
    SendinblueAllowedExtensions["AVI"] = "avi";
})(SendinblueAllowedExtensions || (exports.SendinblueAllowedExtensions = SendinblueAllowedExtensions = {}));
var EmailType;
(function (EmailType) {
    EmailType["VisitorDailyEmail"] = "VisitorDailyEmail";
    EmailType["VisitorMonthlyEmail"] = "VisitorMonthlyEmail";
    EmailType["VisitorWeeklyEmail"] = "VisitorWeeklyEmail";
})(EmailType || (exports.EmailType = EmailType = {}));
var EmailDeliveryStatus;
(function (EmailDeliveryStatus) {
    EmailDeliveryStatus["AwaitingInsert"] = "AwaitingInsert";
    EmailDeliveryStatus["Inserting"] = "Inserting";
    EmailDeliveryStatus["Processing"] = "Processing";
    EmailDeliveryStatus["Completed"] = "Completed";
    EmailDeliveryStatus["Failed"] = "Failed";
    EmailDeliveryStatus["Draft"] = "Draft";
    EmailDeliveryStatus["Pending"] = "Pending";
})(EmailDeliveryStatus || (exports.EmailDeliveryStatus = EmailDeliveryStatus = {}));
var ContactCommunicationType;
(function (ContactCommunicationType) {
    ContactCommunicationType["OneToOne"] = "OneToOne";
    ContactCommunicationType["Bulk"] = "Bulk";
    ContactCommunicationType["Automated"] = "Automated";
    ContactCommunicationType["PostMail"] = "PostMail";
})(ContactCommunicationType || (exports.ContactCommunicationType = ContactCommunicationType = {}));
// Values match the Amplitude tracking plan so the stored reason and the reported one are the same string.
var UnsubscribeReason;
(function (UnsubscribeReason) {
    UnsubscribeReason["TooManyEmails"] = "too_many_emails";
    UnsubscribeReason["NotRelevant"] = "not_relevant";
    UnsubscribeReason["NeverSignedUp"] = "never_signed_up";
    UnsubscribeReason["Other"] = "other";
})(UnsubscribeReason || (exports.UnsubscribeReason = UnsubscribeReason = {}));
// The kinds of CRM email a contact can unsubscribe from separately, and later the From they are sent with.
var CrmEmailType;
(function (CrmEmailType) {
    CrmEmailType["Campaign"] = "campaign";
    CrmEmailType["OneToOne"] = "one_to_one";
    CrmEmailType["Newsletter"] = "newsletter";
})(CrmEmailType || (exports.CrmEmailType = CrmEmailType = {}));
